import { Button, Stack, Typography } from '@mui/material';
import { Component, ErrorInfo, ReactNode } from 'react';

import { appInsights } from '@/utils/appInsightsUtil';

type AppErrorBoundaryProps = {
  children: ReactNode;
};

type AppErrorBoundaryState = {
  hasError: boolean;
};

class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  public state: AppErrorBoundaryState = {
    hasError: false,
  };

  public static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    appInsights.trackException({
      exception: error,
      properties: {
        source: 'react.error-boundary',
        componentStack: errorInfo.componentStack,
      },
    });
  }

  public render(): ReactNode {
    if (this.state.hasError) {
      return (
        <Stack alignItems='center' justifyContent='center' minHeight='100vh' spacing={2}>
          <Typography variant='h5'>Something went wrong.</Typography>
          <Button variant='primary' onClick={() => window.location.reload()}>
            Reload page
          </Button>
        </Stack>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
